import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';
export function FinalSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-blush px-5 py-16 text-center lg:px-8 lg:py-24" data-id="element-91" data-mp="9uwipwkcsltx">
      <div className="mx-auto max-w-4xl" data-id="element-92" data-mp="54g0lz5l8c18">
        <h2 id="final-heading" className="mx-auto max-w-3xl font-display text-[2.4rem] font-bold leading-[1.06] text-brand-charcoal sm:text-[3.2rem]" data-id="element-93" data-mp="52listpm501d">
          Stop Starting Every Class <Accent data-id="element-94" data-mp="etpvtnvqaatk">From Scratch.</Accent>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-95" data-mp="suae8ixqe4mj">
          Your lash and brow teaching resources are organized in one complete system.
        </p>

        <img src={MOCKUP_URL} alt="The complete Lash & Brow Instructor Ready system" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[520px] object-contain" style={{
        filter: 'drop-shadow(0 30px 36px rgba(120, 90, 60, 0.22))'
      }} data-id="element-96" data-mp="2ukc60hkd5set" />

        <CtaBlock label="Yes, I want my teaching system" className="mt-8" data-id="element-97" data-mp="2zipsiklf57gd" />

        <p className="mt-5 font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-gold-dark" data-id="element-98" data-mp="2zgmrl5iq9twv">
          6 Volumes + 5 Bonuses • Instant Digital Access
        </p>
      </div>
    </section>;
}